import LectureLessonStatusModelBase from '../_generated/modelBases/lecture-lesson-status-model-base';

export default class LectureLessonStatusModel extends LectureLessonStatusModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
